import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames';

import { enhancedConnect } from 'utils/lowCodeHelpers';

import styles from './styles.pcss';
import './style.css';

const cx = classNames.bind(styles);

interface ContentDetailsProps {
  html: string;
}

const _ContentDetails: React.FC<ContentDetailsProps> = ({ html }) => (
  <Text
    className={(cx('content'), 'external-content')}
    color="secondary"
    dangerouslySetInnerHTML={{ __html: html }}
    tagName="div"
    variant="body-paragraph-medium"
  />
);

export const ContentDetails = enhancedConnect({})(_ContentDetails);
